import { api } from '@/api';
import { CaseStatus, ResourceLogisticsStatus, RoutePlanStatus } from '@/api/apis/case';
import { Uuid } from '@/api/types';

export const getNextCaseStatusMutation = (caseId: Uuid, nextStatus: CaseStatus) => {
  switch (nextStatus) {
    case CaseStatus.ClinicalScreening:
      return api.case.changeStatusClinicalScreening(caseId);
    case CaseStatus.Accepted:
      return api.case.changeStatusAccepted(caseId);
    case CaseStatus.PendingLogistics:
      return api.case.changeStatusPendingLogistics(caseId);
    case CaseStatus.ResourcesBooked:
      return api.case.changeStatusResourcesBooked(caseId);
    case CaseStatus.ResourceDeployed:
      return api.case.changeStatusResourcesDeployed(caseId);
    case CaseStatus.AtDonorHospital:
      return api.case.changeStatusAtDonorHospital(caseId);
    case CaseStatus.OrganOnOCS:
      return api.case.changeStatusOnOcs(caseId);
    case CaseStatus.DeployedToTXCenter:
      return api.case.changeStatusDeployedToTxCenter(caseId);
    case CaseStatus.AtTXCenter:
      return api.case.changeStatusAtTxCenter(caseId);
    case CaseStatus.OrganOffOCS:
      return api.case.changeStatusOffOcs(caseId);
    case CaseStatus.ReturningToBase:
      return api.case.changeStatusReturningToBase(caseId);
    case CaseStatus.Finished:
      return api.case.changeStatusCaseFinished(caseId);
    case CaseStatus.Closed:
      return api.case.changeStatusCaseClosed(caseId);
    case CaseStatus.ServiceDeclined:
      return api.case.changeStatusRollbackToServiceDeclined(caseId);
    default:
      return api.case.changeToSpecificCaseStatus(caseId, nextStatus);
  }
};

export const getNextRouteStatusMutation = (
  caseId: Uuid,
  currentStatus: RoutePlanStatus,
  comment?: string,
  isSendQuoteInternalMain?: boolean,
) => {
  switch (currentStatus) {
    case RoutePlanStatus.RoutePlanningStart:
      return isSendQuoteInternalMain
        ? api.case.setRouteWaitingForQuoteApproval(caseId, comment)
        : api.case.setRouteWaitingForAviationApproval(caseId, comment);
    case RoutePlanStatus.WaitingForAviationApproval:
      return api.case.setRouteApproveAviation(caseId, comment);
    case RoutePlanStatus.WaitingForQuoteApproval:
      return api.case.setRouteQuoteApprove(caseId, comment);
    case RoutePlanStatus.PendingResourcesBooking:
      return api.case.setRouteResourceBooked(caseId);
    default:
      return api.case.setRouteWaitingForAviationApproval(caseId, comment);
  }
};

export const getCsStatusMutation = (status: ResourceLogisticsStatus) => {
  switch (status) {
    case ResourceLogisticsStatus.DeployedToDonorHospital:
      return api.case.csDeployedToDonorHospital;
    case ResourceLogisticsStatus.AtDonorHospital:
      return api.case.csAtDonor;
    case ResourceLogisticsStatus.DeployedFromDonorHospital:
      return api.case.csDeployedFromDonorHospital;
    case ResourceLogisticsStatus.AtTXCenter:
      return api.case.csAtTxCenter;
    case ResourceLogisticsStatus.DeployedFromTXCenter:
      return api.case.csDeployedFromTxCenter;
    case ResourceLogisticsStatus.Done:
      return api.case.csDone;
    default:
      return api.case.csDone;
  }
};

export const getSurgeonStatusMutation = (status: ResourceLogisticsStatus) => {
  switch (status) {
    case ResourceLogisticsStatus.DeployedToDonorHospital:
      return api.case.surgeonDeployedToDonorHospital;
    case ResourceLogisticsStatus.AtDonorHospital:
      return api.case.surgeonAtDonor;
    case ResourceLogisticsStatus.RecoveryIsCompleted:
      return api.case.surgeonRecoveryCompleted;
    case ResourceLogisticsStatus.DeployedFromDonorHospital:
      return api.case.surgeonDeployedFromDonorHospital;
    case ResourceLogisticsStatus.Done:
      return api.case.surgeonDone;
    default:
      return api.case.surgeonDone;
  }
};

export const getDeviceStatusMutation = (status: ResourceLogisticsStatus) => {
  switch (status) {
    case ResourceLogisticsStatus.OCSDeployed:
      return api.case.consoleDeployed;
    case ResourceLogisticsStatus.OCSDone:
      return api.case.consoleDone;
    default:
      return api.case.consoleDone;
  }
};
